export default "__VITE_ASSET__hPGbu3_M__"